module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-88.2ac6a68b.svg";